import { useQuery, useMutation, useQueryClient } from 'react-query';
import { profileApi } from '../services/api';
import { useToast } from './useToast';
import type { ProfileUpdateData } from '../types';

export function useProfile() {
  const queryClient = useQueryClient();
  const { showSuccess, showError } = useToast();

  const profileQuery = useQuery(['profile'], () => profileApi.getProfile());

  const updateMutation = useMutation(
    (data: ProfileUpdateData) => profileApi.updateProfile(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['profile']);
        showSuccess('Perfil actualizado exitosamente');
      },
      onError: (error) => {
        showError(error, 'Error al actualizar el perfil');
      },
    }
  );

  const avatarMutation = useMutation(
    (file: File) => profileApi.uploadAvatar(file),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['profile']);
        showSuccess('Foto de perfil actualizada exitosamente');
      },
      onError: (error) => {
        showError(error, 'Error al subir la foto de perfil');
      },
    }
  );

  return {
    profile: profileQuery.data,
    isLoading: profileQuery.isLoading,
    error: profileQuery.error,
    updateProfile: updateMutation.mutateAsync,
    uploadAvatar: avatarMutation.mutateAsync,
    isUpdating: updateMutation.isLoading,
    isUploading: avatarMutation.isLoading,
  };
}
